function initMobileMenu() {

  const toggle = document.querySelector('[data-mobile-toggle]');

  const nav = document.querySelector('[data-main-nav]');

  if (!toggle || !nav) return;

  // Évite d'ajouter plusieurs fois le même événement

  if (toggle.dataset.menuInitialized === 'true') return;

  toggle.dataset.menuInitialized = 'true';

  toggle.addEventListener('click', () => {

    const isOpen = nav.classList.contains('is-open');

    nav.classList.toggle('is-open', !isOpen);

    toggle.setAttribute('aria-expanded', String(!isOpen));

  });

}

document.addEventListener('DOMContentLoaded', initMobileMenu);

document.addEventListener('shopify:section:load', initMobileMenu);

document.addEventListener('shopify:section:reorder', initMobileMenu);